module.exports = __webpack_public_path__ + "img/service.77687c6c.png";